(() => {
  const drawer = document.querySelector('[data-product-enquiry-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.product-enquiry-drawer__panel');
  const closeButtons = drawer.querySelectorAll('[data-product-enquiry-close]');
  const boat = drawer.querySelector('[data-product-enquiry-boat]');
  const boatMedia = drawer.querySelector('[data-product-enquiry-media]');
  const boatImage = drawer.querySelector('[data-product-enquiry-image]');
  const boatTitle = drawer.querySelector('[data-product-enquiry-title]');
  const boatPrice = drawer.querySelector('[data-product-enquiry-price]');
  const boatLocation = drawer.querySelector('[data-product-enquiry-location]');
  const boatInput = drawer.querySelector('[data-product-enquiry-boat-input]');
  const urlInput = drawer.querySelector('[data-product-enquiry-url-input]');
  const status = drawer.querySelector('[data-product-enquiry-status]');
  const nameInput = drawer.querySelector('input[autocomplete="name"]');
  let opener = null;
  let scrollPosition = 0;

  const getFocusableElements = () =>
    [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(
      (element) => element.getClientRects().length
    );

  const setBoatContext = (trigger) => {
    const title = trigger?.dataset.boatTitle || '';
    const price = trigger?.dataset.boatPrice || '';
    const location = trigger?.dataset.boatLocation || '';
    const image = trigger?.dataset.boatImage || '';
    const url = trigger?.dataset.boatUrl || trigger?.href || '';

    boatTitle.textContent = title;
    boatPrice.textContent = price;
    boatLocation.textContent = location;
    boatInput.value = title;
    urlInput.value = url;
    boat.hidden = !title;

    if (image) {
      boatImage.src = image;
      boatImage.alt = title;
      boatMedia.hidden = false;
    } else {
      boatImage.removeAttribute('src');
      boatImage.alt = '';
      boatMedia.hidden = true;
    }
  };

  const openDrawer = (trigger = null) => {
    if (drawer.classList.contains('is-open')) return;
    opener = trigger || document.activeElement;
    setBoatContext(trigger);
    scrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.right = '0';
    document.body.style.left = '0';
    document.body.style.width = '100%';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('product-enquiry-drawer-is-open');
    window.setTimeout(() => (status || nameInput || closeButtons[1])?.focus({ preventScroll: true }), 40);
  };

  const closeDrawer = () => {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('product-enquiry-drawer-is-open');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
    opener?.focus({ preventScroll: true });
    opener = null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-enquiry-open]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openDrawer(trigger);
  });

  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements();
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (status) openDrawer();
})();
